export interface PaycheckRoutingConfig {
    id: string;
    accountId: string;
    originator: string;
    receiver: string;
    isActive: boolean;
    status: PaycheckRoutingStatus;
    updatedAt?: Date | null;
    rules?: PaycheckRoutingRule[] | null;
    isLegacy?: boolean;
}

export enum PaycheckRoutingStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED',
}

export enum PaycheckRoutingConfigStatus {
    ENABLED = 'ENABLED',
    ELIGIBLE = 'ELIGIBLE',
    DISABLED = 'DISABLED',
}

export enum PaycheckRoutingRuleType {
    FIXED = 'FIXED',
    MINIMUM_BALANCE = 'MINIMUM_BALANCE',
    PERCENTAGE = 'PERCENTAGE',
}

export enum PaycheckRoutingRuleAccountType {
    INTERNAL_DEPOSITORY = 'INTERNAL_DEPOSITORY',
    INTERNAL_BROKERAGE = 'INTERNAL_BROKERAGE',
    INTERNAL_INVESTMENT = 'INTERNAL_INVESTMENT',
    EXTERNAL = 'EXTERNAL',
}

export interface PaycheckRoutingRule {
    id: string;
    type: PaycheckRoutingRuleType;
    amount: number;
    order: number;
    accountId: string;
    paycheckRoutingConfigId?: string;
    accountMetadata?: PaycheckRoutingRuleAccountMetadata;
    accountType?: PaycheckRoutingRuleAccountType;
}

export interface PaycheckRoutingRuleAccountMetadata {
    icon?: string | null;
    color?: string | null;
    nickname?: string | null;
}

export const PaycheckRoutingRuleNames: Record<string, string> = {
    [PaycheckRoutingRuleType.FIXED]: 'Transfer funds',
    [PaycheckRoutingRuleType.MINIMUM_BALANCE]: 'Replenish account balance',
};

export const PaycheckRoutingRuleDescriptions: Record<string, string> = {
    [PaycheckRoutingRuleType.FIXED]: 'Send an exact dollar amount',
    [PaycheckRoutingRuleType.MINIMUM_BALANCE]:
        'Send only what is needed to reach a target balance',
};

export enum PaycheckRoutingRulesMode {
    CREATE = 'create',
    EDIT = 'edit',
}

export interface PaycheckRoutingIncomeDetail {
    accountId: string;
    originator: string;
    receiver: string;
    rawDescription: string;
    amount: number;
}
